import { defineFcm } from '../shared/factory';

export const FCM_PSF_CONTACT_DECISION_MAKER_ENABLED = defineFcm('psf_contact_decision_maker_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Supporter → DM Outreach',
		description:
			'Gates the contact-decision-maker ask in the post-sign flow (the actions page, after a Supporter Voices comment): off, the ask does not render. Same shape as `sph_contact_decision_maker_enabled`: a single global row set to `true` enables it everywhere; use a country or locale row to narrow the rollout (most specific row wins). The petition must still have a contactable local or state decision maker. The middle-end also reads it: `Petition.viewerHasContactedDecisionMaker` answers while either this or the SPH switch is on.',
	});
